import MasterWinePage from '@pages/pdp/lowerSection/masterWinePage';
import OffersPage from '@pages/pdp/lowerSection/offersPage/offersPage';
import VintagePage from '@pages/pdp/lowerSection/vintagePage';
import WinePageTopSection from '@pages/pdp/topSection/topSection';
import { hydrateWithEmotion } from '@utils/ssr/clientRenderer';

const ReactOnRails = (window.ReactOnRails =
  window.ReactOnRails || require('react-on-rails').default);

ReactOnRails.register({
  WinePageTopSection: hydrateWithEmotion(WinePageTopSection),
});

ReactOnRails.register({
  VintagePageLowerSection: hydrateWithEmotion(VintagePage),
});

ReactOnRails.register({
  MasterWinePageLowerSection: hydrateWithEmotion(MasterWinePage),
});

ReactOnRails.register({
  OffersPageLowerSection: hydrateWithEmotion(OffersPage),
});
